import Footer from '../Footer';
import LandingNav from '../LandingNav';

export default function LayoutGuest({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <main className="w-full">
      <LandingNav />
      <div className="md:mb-20 mb-12 pb-4" />
      <section className={` ${className} flex flex-col min-h-screen gap-4 w-full mx-auto`}>{children}</section>
      <Footer />
    </main>
  );
}
